import Listing from "./scripts/components/Listing";
import { format } from "date-fns";
import flatpickr from "flatpickr";

class WhatsOnAccessListing {
    constructor(element) {
        this.el = element;
        this.form = document.getElementById("whats-on-access-filters-form");
        this.picker = this.form.querySelector(".date-picker");
        this.intervals = document.querySelectorAll('[name="interval"]');
        this.labelFieldRadios =
            this.form.querySelectorAll(`.label-field--radio`);

        this.init();
    }

    init() {
        this.setupDatePicker();

        this.intervals.forEach((item) => {
            item.addEventListener(
                "change",
                this.handleIntervalChange.bind(this),
            );
        });

        if (this.el) {
            this.listing = new Listing({
                root: this.el,
                form: this.form,
                listingId: "whats-on-access",
                daterange: "dates",
                pagination: {
                    el: ".pagination",
                    perPage: 16,
                },
                html: "/wp-content/uploads/whats-on-access.html",
                json: "/wp-content/uploads/whats-on-access.json",
                objectName: {
                    singular: "event",
                    plural: "events",
                },
                callback: () => {
                    console.log(this.listing.state.filtersStatus);
                },
            });
        }
    }

    setupDatePicker() {
        this.calendar = flatpickr(this.picker, {
            wrap: true,
            mode: "range",
            minDate: "today",
            altInput: true,
            altFormat: "d/m/y",
            dateFormat: "Y-m-d",
            monthSelectorType: "static",
            locale: {
                firstDayOfWeek: 1,
                rangeSeparator: "/",
            },
            positionElement: this.picker,
            prevArrow: `<span class="mask-icon"></span>`,
            nextArrow: `<span class="mask-icon"></span>`,
            onChange: this.handleDateChange.bind(this),
            onOpen: () => {
                this.picker.classList.add("is-open");
            },
            onClose: () => {
                this.picker.classList.remove("is-open");
            },
        });
    }

    handleDateChange(selectedDates, dateStr, instance) {
        if (!selectedDates.length) {
            this.picker.classList.remove("has-value");
        } else {
            this.picker.classList.add("has-value");
        }

        instance.element.value = dateStr.replace(" to ", "/");

        if (this.picker?.value) {
            this.intervals.forEach((item) => {
                item.checked = false;
            });
        }
    }

    handleIntervalChange() {
        this.calendar.clear();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById("whats-on-access-listing");

    if (element) {
        new WhatsOnAccessListing(element);
    }
});
